<form #form="ngForm" (ngSubmit)="save(form)">
  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <input  pInputText
                id="workarea" name="workarea"
                class="p-inputtext-sm"
                [(ngModel)]="workArea.areaName"/>
        <label for="workarea">Work Area</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-multiSelect [options]="employees" 
                        class="p-inputtext-sm" 
                        name="employees"
                        appendTo="body"
                        [showHeader]="true"
                        [filter]="true"
                        [showToggleAll]="false"
                        inputId="employees" 
                        optionLabel="name"
                        dataKey="id"
                        [maxSelectedLabels]="1"
                        [(ngModel)]="workArea.teamLeaders">
        </p-multiSelect>
        <label for="employees">Team Leaders</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-2">
      <input readonly
            [cpWidth]="250"
            [value]="'Color Code'"
            [style]="{backgroundColor: workArea.color, width:'100%', height:'30px', textAlign:'center', border: '1px solid #cccccc', borderRadius:'4px'}"
            [cpPresetColors]="presetColors"
            [cpPosition]="'left'"
            [cpAlphaChannel]="'disabled'"
            [cpOutputFormat]="'hex'"
            [(colorPicker)]="workArea.color"/>
    </div>
    
    <div class="p-field p-col-12 p-md-3 p-mt-2">
      <div class="p-field-checkbox">
        <p-checkbox [(ngModel)]="workArea.signOnSheet" binary="true" inputId="signOnSheet" name="signOnSheet"></p-checkbox>
        <label for="signOnSheet">Print Sign On Sheet</label>
      </div>
    </div>
  </div> 
  
  <div class="modal-footer">
    <button pButton pRipple label="Ok" class="p-button" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>
